import styled from 'styled-components';

const SelectTitle = styled.div`
  font-size: 14px;
  color: ${p => p.theme.grey700};
  margin-bottom: 5px;
`;

export default SelectTitle;
